import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import HistoryLineChart from '../../common/HistoryLineChart';

// Prepare data for chart
const formattedData = (data, authors) => {
    // Process data
    const processedData = data.reduce((acc, pr) => {
        const dateObj = new Date(pr.createDate);
        const date = `${dateObj.getMonth() + 1}/${dateObj.getDate()}/${dateObj.getFullYear()}`; // MM/DD/YYYY
        if (!acc[date]) {
            acc[date] = { date };
            authors.forEach(author => acc[date][author] = 0);
        }
        acc[date][pr.author] = (acc[date][pr.author] || 0) + 1; // Increment PR count
        return acc;
    }, {});

    // Convert object to array and sort by date
    const sortedData = Object.values(processedData).sort((a, b) => new Date(a.date) - new Date(b.date));

    // Ensure all dates have data for each author
    authors.forEach(author => {
        sortedData.forEach(item => {
            if (!item[author]) {
                item[author] = 0;
            }
        });
    });

    return sortedData;
}

const PRLineChart = ({ data }) => {
    const [chartData, setChartData] = useState([]);
    const authors = useMemo(() => [...new Set(data.map(pr => pr.author))], [data]);

    useEffect(() => {
        let processedData = formattedData(data, authors);
        if (Object.values(processedData)) {
            setChartData(Object.values(processedData));
        }
    }, [data, authors]);

    return chartData.length > 0 ? (
        <div style={{ border: '1px solid #ccc', padding: '20px', borderRadius: '8px', backgroundColor: '#f9f9f9', textAlign: 'center' }}>
            <h4 style={{ marginBottom: '20px' }}>Developer PR History</h4>
            <HistoryLineChart
                authors={authors}
                chartData={chartData}
                yAxisLabel='PR Count'
            />
        </div>
    ):(null)
};

// PropTypes validation
PRLineChart.propTypes = {
    data: PropTypes.array.isRequired,
};

export default PRLineChart;